import { render, staticRenderFns } from "./image-file.vue?vue&type=template&id=1ff40633&scoped=true&"
import script from "./image-file.vue?vue&type=script&lang=js&"
export * from "./image-file.vue?vue&type=script&lang=js&"
import style0 from "./image-file.vue?vue&type=style&index=0&id=1ff40633&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff40633",
  null
  
)

export default component.exports